// extracted by mini-css-extract-plugin
export default {"container":"Cree_container__QneXX","mimo":"Cree_mimo__seoKw","textBox":"Cree_textBox__tAKww","textList":"Cree_textList__ygNc-"};